const e=(e,c)=>o=>c(e(o)),c=(...c)=>c.reduce(e);export{c as pipe};
